<template>
  <div class="relative h-[207px] md:h-auto">
    <ImageRenderer
      :alt="bannerImage.alt"
      class="flex h-full justify-center"
      :height="bannerImage.height"
      :height-mobile="bannerImage.heightMobile"
      :loading="Loading.Eager"
      :src="bannerImage.src"
      :src-mobile="bannerImage.srcMobile"
      :width="bannerImage.width"
      :width-mobile="bannerImage.widthMobile"
    />

    <div
      v-if="breadcrumbTextColor === BannerTextColor.White"
      class="from-bg-surface-default-low mood-bush absolute -left-96 top-0 size-full bg-gradient-to-r to-transparent sm:-left-[25rem]"
      data-test="hero-banner-overlay"
    />

    <div
      v-if="displayBreadcrumb"
      class="absolute top-0 flex w-full justify-center"
    >
      <Breadcrumb
        class="mx-auto max-w-full grow lg:max-w-[1184px] lg:basis-full"
        :class="{
          [$style.whiteBreadcrumb]:
            breadcrumbTextColor === BannerTextColor.White,
        }"
        :current-page-title
        data-test="article-breadcrumb"
        :intermediary-path
        @breadcrumb-clicked="(title: string) => tracking(title)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { BannerTextColor } from '@backmarket/http-api/src/api-specs-content/models/banner'
import type { Image } from '@backmarket/http-api/src/api-specs-content/models/image'
import { Loading } from '@backmarket/nuxt-layer-cms/ImageRenderer.constants'
import ImageRenderer from '@backmarket/nuxt-layer-cms/ImageRenderer.vue'

import Breadcrumb from '../../../cms/shared-components/Breadcrumb/Breadcrumb.vue'
import type { Crumb } from '../../../cms/shared-components/Breadcrumb/crumb'

defineProps<{
  bannerImage: Image
  currentPageTitle: string
  intermediaryPath: Crumb[]
  tracking: (title: string) => void
  breadcrumbTextColor?: BannerTextColor
  displayBreadcrumb: boolean
}>()
</script>

<style module>
.whiteBreadcrumb {
  li,
  li > a,
  span {
    @apply text-static-light-hi;
  }
}
</style>
